// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as PressRouteImport } from './routes/press'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as HubsRouteImport } from './routes/hubs'
import { Route as DataRouteImport } from './routes/data'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AnswersRouteImport } from './routes/answers'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexingRouteImport } from './routes/admin.indexing'
import { Route as ToolsRoiCalculatorRouteImport } from './routes/tools.roi-calculator'
import { Route as ServicesServiceRouteImport } from './routes/services.$service'
import { Route as ServiceAreasCityRouteImport } from './routes/service-areas.$city'
import { Route as SeoIndexRouteImport } from './routes/seo.index'
import { Route as IndustriesIndustryRouteImport } from './routes/industries.$industry'
import { Route as HubsTradeRouteImport } from './routes/hubs.$trade'
import { Route as DataTradesCpcRouteImport } from './routes/data.trades-cpc'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AnswersSlugRouteImport } from './routes/answers.$slug'
import { Route as SeoTradeCityRouteImport } from './routes/seo.$trade.$city'
import { Route as SeoTradeCityProblemRouteImport } from './routes/seo.$trade.$city.$problem'

const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const SeoRoute = SeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const HubsRoute = HubsRouteImport.update({
            id: '/hubs',path: '/hubs',getParentRoute: () => rootRouteImport
          })
const DataRoute = DataRouteImport.update({
            id: '/data',path: '/data',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AnswersRoute = AnswersRouteImport.update({
            id: '/answers',path: '/answers',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminIndexingRoute = AdminIndexingRouteImport.update({
            id: '/admin/indexing',path: '/admin/indexing',getParentRoute: () => rootRouteImport
          })
const ToolsRoiCalculatorRoute = ToolsRoiCalculatorRouteImport.update({
            id: '/roi-calculator',path: '/roi-calculator',getParentRoute: () => ToolsRoute
          })
const ServicesServiceRoute = ServicesServiceRouteImport.update({
            id: '/$service',path: '/$service',getParentRoute: () => ServicesRoute
          })
const ServiceAreasCityRoute = ServiceAreasCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => ServiceAreasRoute
          })
const SeoIndexRoute = SeoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SeoRoute
          })
const IndustriesIndustryRoute = IndustriesIndustryRouteImport.update({
            id: '/$industry',path: '/$industry',getParentRoute: () => IndustriesRoute
          })
const HubsTradeRoute = HubsTradeRouteImport.update({
            id: '/$trade',path: '/$trade',getParentRoute: () => HubsRoute
          })
const DataTradesCpcRoute = DataTradesCpcRouteImport.update({
            id: '/trades-cpc',path: '/trades-cpc',getParentRoute: () => DataRoute
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AnswersSlugRoute = AnswersSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AnswersRoute
          })
const SeoTradeCityRoute = SeoTradeCityRouteImport.update({
            id: '/$trade/$city',path: '/$trade/$city',getParentRoute: () => SeoRoute
          })
const SeoTradeCityProblemRoute = SeoTradeCityProblemRouteImport.update({
            id: '/$problem',path: '/$problem',getParentRoute: () => SeoTradeCityRoute
          })





const AnswersRouteChildren = {
  AnswersSlugRoute: AnswersSlugRoute
}

const AnswersRouteWithChildren = AnswersRoute._addFileChildren(AnswersRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const DataRouteChildren = {
  DataTradesCpcRoute: DataTradesCpcRoute
}

const DataRouteWithChildren = DataRoute._addFileChildren(DataRouteChildren)




const HubsRouteChildren = {
  HubsTradeRoute: HubsTradeRoute
}

const HubsRouteWithChildren = HubsRoute._addFileChildren(HubsRouteChildren)




const IndustriesRouteChildren = {
  IndustriesIndustryRoute: IndustriesIndustryRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const SeoTradeCityRouteChildren = {
  SeoTradeCityProblemRoute: SeoTradeCityProblemRoute
}

const SeoTradeCityRouteWithChildren = SeoTradeCityRoute._addFileChildren(SeoTradeCityRouteChildren)



const SeoRouteChildren = {
  SeoIndexRoute: SeoIndexRoute,SeoTradeCityRoute: SeoTradeCityRouteWithChildren
}

const SeoRouteWithChildren = SeoRoute._addFileChildren(SeoRouteChildren)




const ServiceAreasRouteChildren = {
  ServiceAreasCityRoute: ServiceAreasCityRoute
}

const ServiceAreasRouteWithChildren = ServiceAreasRoute._addFileChildren(ServiceAreasRouteChildren)




const ServicesRouteChildren = {
  ServicesServiceRoute: ServicesServiceRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const ToolsRouteChildren = {
  ToolsRoiCalculatorRoute: ToolsRoiCalculatorRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AboutRoute: AboutRoute,AnswersRoute: AnswersRouteWithChildren,BlogRoute: BlogRouteWithChildren,CaseStudiesRoute: CaseStudiesRouteWithChildren,ContactRoute: ContactRoute,DataRoute: DataRouteWithChildren,HubsRoute: HubsRouteWithChildren,IndustriesRoute: IndustriesRouteWithChildren,PressRoute: PressRoute,SeoRoute: SeoRouteWithChildren,ServiceAreasRoute: ServiceAreasRouteWithChildren,ServicesRoute: ServicesRouteWithChildren,ToolsRoute: ToolsRouteWithChildren,AdminIndexingRoute: AdminIndexingRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)